import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setQuizPlayedOnce } from 'store/slices/userInteractionSlice';
import { getTimeLeftForNextQuiz } from 'utils/commonFunctions';
const NextQuizTime = () => {
  const dispatch = useDispatch();

  const [quizTime, setQuizTime] = React.useState(getTimeLeftForNextQuiz(new Date()));

  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date();

      setQuizTime(getTimeLeftForNextQuiz(currentTime));


      if (
        currentTime.getUTCHours() === 0 &&
        currentTime.getUTCMinutes() === 0 &&
        currentTime.getUTCSeconds() === 0
      ) {
        dispatch(setQuizPlayedOnce(false));
      }
    }, 1000);

    () => {
      clearInterval(interval);
    };
  }, []);

  if (quizTime) {
    const { hours, minutes } = quizTime;

    return (
      <div className='si-timer__status'>
        <div className='si-timer__icon'>
          <i className='qz-clock'></i>
        </div>
        <div className='si-timer__text'>
          <em>{hours}</em>h <em>{minutes}</em>m until the next quiz
        </div>
      </div>
    );
  }
};

export default NextQuizTime;
